import React from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import { UploadCsvStep } from './Steps/UploadCsvStep';

import { CustomFundLineupProvider } from '../../contexts/CustomFundLineupContext';

export const CustomFundLineupFlow: React.FC = () => {
  return (
    <CustomFundLineupProvider>
      <Routes>
        <Route index={true} element={<Navigate to="upload" replace={true} />} />
        <Route path="upload" element={<UploadCsvStep />} />
      </Routes>
    </CustomFundLineupProvider>
  );
};
